import apiHelper from "./apiHelper";
import axios from "axios";
import { create } from "apisauce";
import { getApiInformation } from "../helpers/apiHelper";

export const rootUrl = process.env.REACT_APP_PAYMENT_URL;

export const commonRootUrl ="https://tahsilat.elogo.com.tr"
// const rootUrl =commonRootUrl+  "/etahsilatpaymentapi";


const api = create({
  baseURL: rootUrl,
})

type apiParams={
licenseKey: string,
taxCode: string,
passLicenseControl?: boolean
}

const apiInfo = getApiInformation();
const paymentApi = {

  get: async function (method: string, params: any, apiParams: apiParams) {
    const licenseKey = apiParams?.licenseKey;
    const taxCode= apiParams?.taxCode;
    const {apiKey, apiSecret} = apiInfo;
    let headerAuth="";
    if (apiParams.passLicenseControl) {
      headerAuth = btoa(apiKey + ":" + apiSecret);
    }else{
      headerAuth = btoa(apiKey + ":" + apiSecret+":"+licenseKey + ":" + taxCode);
    }



    const response = await api.get(method, params, {
      headers:{
        Authorization: `basic ${headerAuth}`
      }
    });

    if (response.ok) {
      return apiHelper.apiSuccess({ result: response, passControl: true });
    } else {
      return apiHelper.apiError({ errorMsg: response.data });
    }
  },

  post: async function (method: string, params: any, apiParams: apiParams) {

    const licenseKey = apiParams?.licenseKey;
    const taxCode= apiParams?.taxCode;
    const {apiKey, apiSecret} = apiInfo;

    let headerAuth="";
    if (apiParams.passLicenseControl) {
      headerAuth = btoa(apiKey + ":" + apiSecret);
    }else{
      headerAuth = btoa(apiKey + ":" + apiSecret+":"+licenseKey + ":" + taxCode);
    }


    const response = await api.post(method, params, {
      headers:{
        Authorization: `basic ${headerAuth}` ,
        "Content-Type": "application/json; charset=utf-8",
        "Accept": "application/json"
      }
    });

    if (response.ok) {
      return apiHelper.apiSuccess({
        result: response,
        passControl:true
      });
    } else {
      return apiHelper.apiError({ errorMsg: response.data });
    }

  }
}

export default paymentApi;